"use client";

import { PayPalExpressCheckoutBase } from "../PayPalExpressCheckoutBase";

import { useCreateBasket } from "./useCreateBasket";

/** v2 wrapper: resolves the v2 (`api.Checkout`) `createBasket` function and
 * forwards it to `<PayPalExpressCheckoutBase>`. The hook itself is currently
 * a stub that throws on invocation — wiring up v2 (data sources, action
 * plumbing, Stripe intent retrieval) is intentionally out of scope of this
 * change so the v1 path can ship behind the new dispatcher shape. */
export function PayPalExpressCheckoutV2({
  price,
  onSuccess,
  onError,
}: Readonly<{
  price: number;
  onSuccess: () => void;
  onError: (message: string) => void;
}>) {
  const { createBasket } = useCreateBasket();

  return (
    <PayPalExpressCheckoutBase
      price={ price }
      createBasket={ createBasket }
      onSuccess={ onSuccess }
      onError={ onError }
    />
  );
}
